import NotificationsTemplate from './NotificationsTemplate'

export default NotificationsTemplate
